var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { attrs: { id: "brand-animation" } }, [
    _c("div", { staticClass: "row justify-content-between" }, [
      _c("div", { staticClass: "col-12 col-lg-3" }, [
        _c("h2", {
          directives: [
            {
              name: "msh-html",
              rawName: "v-msh-html",
              value: _vm.brandAnimation.title,
              expression: "brandAnimation.title",
            },
          ],
          staticClass: "mt-lg-5",
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-lg-9" }, [
        _c(
          "ul",
          { staticClass: "advantage-list row ps-0 ps-lg-3" },
          [
            _vm._l(
              _vm.brandAnimation.brandAdvantages,
              function (advantage, index) {
                return _c(
                  "li",
                  {
                    key: "adv-" + index,
                    staticClass: "col-12 col-md-6 mb-1 mb-md-2 px-1",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "advantage-item h-100 bg-white p-2" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "mb-1 d-flex justify-content-center d-webview-none",
                          },
                          [
                            _c("span", {
                              staticClass: "advantage-icon text-primary",
                              class: [advantage.icon],
                              attrs: { "aria-hidden": "true" },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "mt-md-0 mb-md-2" }, [
                          _c("h3", {
                            directives: [
                              {
                                name: "msh-html",
                                rawName: "v-msh-html",
                                value: advantage.title,
                                expression: "advantage.title",
                              },
                            ],
                            staticClass: "h4 py-0",
                          }),
                          _vm._v(" "),
                          _c("p", {
                            directives: [
                              {
                                name: "msh-html",
                                rawName: "v-msh-html",
                                value: advantage.text,
                                expression: "advantage.text",
                              },
                            ],
                            staticClass: "text-gray3 mb-0 py-0",
                          }),
                          _vm._v(" "),
                          advantage.url
                            ? _c("a", {
                                directives: [
                                  {
                                    name: "msh-html",
                                    rawName: "v-msh-html",
                                    value: advantage.labelUrl,
                                    expression: "advantage.labelUrl",
                                  },
                                ],
                                staticClass:
                                  "pt-1 align-self-center ob1-link-arrow ob1-link-large",
                                attrs: {
                                  href: advantage.url,
                                  target: "_blank",
                                  "data-oevent-category": "avantages",
                                  "data-oevent-label": "ouverture-lien",
                                  "data-oevent-action": advantage.labelUrl,
                                },
                              })
                            : _vm._e(),
                        ]),
                      ]
                    ),
                  ]
                )
              }
            ),
            _vm._v(" "),
            _c("li", { staticClass: "col-12 px-1 mb-2" }, [
              _c(
                "div",
                { staticClass: "d-lg-none advantage-item h-100 bg-white p-2" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "mb-1 d-flex justify-content-center d-webview-none",
                    },
                    [
                      _c("img", {
                        staticClass: "advantages-picto d-lg-flex",
                        attrs: {
                          loading: "lazy",
                          alt: "",
                          src: _vm.brandAnimation.reloadMarquePicto,
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-md-0 mb-md-2" }, [
                    _c("h3", {
                      directives: [
                        {
                          name: "msh-html",
                          rawName: "v-msh-html",
                          value: _vm.brandAnimation.reloadMarqueTitle,
                          expression: "brandAnimation.reloadMarqueTitle",
                        },
                      ],
                      staticClass: "h4 py-0 mb-0",
                    }),
                    _vm._v(" "),
                    _c("p", {
                      directives: [
                        {
                          name: "msh-html",
                          rawName: "v-msh-html",
                          value: _vm.brandAnimation.reloadMarqueText,
                          expression: "brandAnimation.reloadMarqueText",
                        },
                      ],
                      staticClass: "text-gray3 mb-0 py-0",
                    }),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-none d-lg-block bg-white advantage-item" },
                [
                  _c("div", { staticClass: "d-lg-flex justify-content-end" }, [
                    _c("img", {
                      staticClass: "advantages-image",
                      attrs: {
                        loading: "lazy",
                        alt: "",
                        src: _vm.brandAnimation.image,
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-none d-lg-block advantages-reload position-absolute bg-white mb-1 pe-1",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "mb-1 d-flex justify-content-start d-webview-none",
                        },
                        [
                          _c("img", {
                            staticClass: "advantages-picto d-lg-flex",
                            attrs: {
                              loading: "lazy",
                              alt: "",
                              src: _vm.brandAnimation.reloadMarquePicto,
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-md-0 mb-md-1" }, [
                        _c("h3", {
                          directives: [
                            {
                              name: "msh-html",
                              rawName: "v-msh-html",
                              value: _vm.brandAnimation.reloadMarqueTitle,
                              expression: "brandAnimation.reloadMarqueTitle",
                            },
                          ],
                          staticClass: "h4 py-0 mb-0",
                        }),
                        _vm._v(" "),
                        _c("p", {
                          directives: [
                            {
                              name: "msh-html",
                              rawName: "v-msh-html",
                              value: _vm.brandAnimation.reloadMarqueText,
                              expression: "brandAnimation.reloadMarqueText",
                            },
                          ],
                          staticClass: "text-gray3 mb-0 py-0",
                        }),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }